import {
    mdiBottleSodaClassicOutline,
    mdiLockerMultiple
} from '@mdi/js'

const user = JSON.parse(localStorage.getItem('user')) || {}
const email = user.email || 'email@prs-invivo-group.com'
const favorite_teams_group = user.favorite_teams_group || 0
const office = user.office || 1

export default [
  {
    subheader: 'SKUTOPIA',
    resource: 'skutopia',
    action: 'read'
  },
  {
    title: 'POGs',
    icon: mdiLockerMultiple,
    to: 'planogram-list',
    resource: 'skutopia',
    action: 'read'
  },
  {
    title: 'Products',
    icon: mdiBottleSodaClassicOutline,
    to: 'product-list',
    resource: 'skutopia',
    action: 'read'
  },
]